import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { FacilityPage, FacilityPageTab } from 'pages/app/facility/FacilityPage'
import { getFacility } from 'api/facility.api'

const facilitySearchSchema = z.object({
  tab: z.nativeEnum(FacilityPageTab).optional().catch(FacilityPageTab.Overview),
});

export const Route = createFileRoute(
  '/_authenticated/app/kunder/$customerId/facility/$facilityId/'
)({
  validateSearch: facilitySearchSchema,
  beforeLoad: async ({ context: { queryClient }, params }) => {
    await queryClient.ensureQueryData(getFacility(Number(params.facilityId)));
  },
  component: FacilityPage,
})
